import { lazy } from "react";
// import { Outlet } from "react-router-dom";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { HOME, NOT_FOUND, CART } from "./paths";
import MainLayout from "../layout/MainLayout";
import Loadable from "../components/ui/Loadable/Loadable";

const HomePage = Loadable(lazy(() => import("../pages/HomePage/HomePage")));
const PrivacyPolicyPage = Loadable(lazy(() => import("../pages/PrivacyPolicyPage/PrivacyPolicyPage")));
const ProductsPage = Loadable(lazy(() => import("../pages/ProductsPage/ProductsPage")));
const ProductDetailsPage = Loadable(lazy(() => import("../pages/ProductDetailsPage/ProductDetailsPage")));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CartPage = Loadable(lazy(() => import("../pages/CartPage/CartPage")));
const NotFoundPage = Loadable(
  lazy(() => import("../pages/NotFoundPage/NotFoundPage"))
);
const CheckoutPage = Loadable(lazy(() => import("../pages/CheckoutPage/CheckoutPage")));

const MainRoutes = {
  path: HOME,
  element: <MainLayout />,
  children: [
    {
      path: "",
      element: <HomePage />,
    },
    {
      path: "privacy-policy",
      element: <PrivacyPolicyPage />,
    },
    {
      path: "products",
      element: <ProductsPage />,
    },
    {
      path: "products/:id",
      element: <ProductDetailsPage />,
    },
    {
      path: CART,
      element: <CartPage />,
    },
    {
      path: "/checkout",
      element: <CheckoutPage />,
    },
    // {
    //     path: "/some-path",
    //     element: <div><Outlet /></div>,
    //     children: [
    //         {
    //             path: '',
    //             element: <div></div>
    //         },
    //         {
    //             path: ':paramId',
    //             element: <SomePage />
    //         },
    //     ]
    // },
    {
      path: NOT_FOUND,
      element: <NotFoundPage />,
    },
  ],
};

export default MainRoutes;
